import { render, staticRenderFns } from "./ThreadsCardLink.vue?vue&type=template&id=24a303e3&scoped=true"
import script from "./ThreadsCardLink.vue?vue&type=script&lang=js"
export * from "./ThreadsCardLink.vue?vue&type=script&lang=js"
import style0 from "./ThreadsCardLink.vue?vue&type=style&index=0&id=24a303e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a303e3",
  null
  
)

export default component.exports